// extracted by mini-css-extract-plugin
module.exports = {"companySetNotification":"CompanySetNotification_companySetNotification__3gSGp","title":"CompanySetNotification_title___gCfp","text":"CompanySetNotification_text__1yQHy"};